//router
import React from "react";
import { Routes, Route } from "react-router-dom";
import MainPage from "../views/MainPage/view";
import ProjectDetail from "../views/ProjectDetail/index";

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/project/:slug" element={<ProjectDetail />} />
      <Route path="*" element={<MainPage />} />
    </Routes>
  );
};

export default AppRouter;
